
















































































import { Component, Vue,Prop } from "vue-property-decorator";
import TransferRegion from "@/store/entities/transferRegion";
import Ajax from '../../../../lib/ajax';

@Component({})

export default class AddTransferRegion extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;

  @Prop()
  transferRegion!: TransferRegion;

  data() {
    return {
      title: "Preliminary report",
      item:{},
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
    
  }

  async updateRegion() {
  await Ajax.put(
        '/api/services/app/Transfer/UpdateRegion',this.transferRegion
      );
      Vue.$toast.success("Kayıt Güncellendi");
      this.closeDialog();
  }

  
  closeDialog() {
    this.$emit("closed");
  
  }

  cancelDialog() {
    this.$emit("cancel");
  }
}
